var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{attrs:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event)},"change":function($event){return _vm.$emit('change', $event)}}},_vm._l((_vm.options),function(item){return _c('el-option',{key:item.value,attrs:{"value":item.type,"label":item.name}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }